import { getDictMap } from '@/api/dict'

/**
 * 业务页字典下拉数据混入：把字典选项拉到本页 data 字段
 * 后端 GET /dict/map 只返回启用项、按 sort 升序，条目为 {label, _id, ...}
 * 业务表提交/存储用数字 _id（转字符串绑下拉），value 仅备注不再作引用
 * 用法：mixins: [dictOptions]，data 声明对应数组字段，created 里调：
 *   this.loadDictOptions({ activity_category: 'categories' })
 * 拉取失败静默（下拉为空），不阻塞页面主数据加载
 */
export default {
  methods: {
    /**
     * @param {Object} mapping 字典编码 → 本页数据字段名
     */
    async loadDictOptions(mapping) {
      const codes = Object.keys(mapping || {})
      if (!codes.length) return
      let res = null
      try {
        res = await getDictMap({ codes: codes.join(',') })
      } catch (e) {
        return
      }
      if (!res || res.code !== 200) return
      const map = res.data || {}
      codes.forEach((code) => {
        const key = mapping[code]
        if (key) this[key] = map[code] || []
      })
    }
  }
}
